var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xl", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h5", [
                _vm._v(_vm._s(_vm.$t("map.gps.tracker.modal.list.title")))
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.dismiss.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _c("VueGoodTable", {
                  attrs: {
                    columns: _vm.columnsConfig,
                    rows: _vm.store.gpsTrackers,
                    "pagination-options": _vm.paginationOptions,
                    "search-options": _vm.searchOptions
                  },
                  on: {
                    "on-row-click": function($event) {
                      return _vm.editGpsTracker($event.row)
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "emptystate",
                      fn: function() {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("txtSearchNoRows")) +
                              "\n          "
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "table-row",
                      fn: function(props) {
                        return [
                          props.column.field === "actions"
                            ? _c("span", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-sm btn-danger",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.deleteConfirm(props.row)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-dumpster" })]
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      props.formattedRow[props.column.field]
                                    ) +
                                    "\n            "
                                )
                              ])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _vm.canEdit
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-success mr-auto",
                        attrs: { type: "button" },
                        on: { click: _vm.addGpsTracker }
                      },
                      [_c("i", { staticClass: "fa fa-plus" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.dismiss }
                  },
                  [_vm._v("Close")]
                ),
                _vm._v(" "),
                _c("GpsTrackerEditModal", { ref: "editModal" })
              ],
              1
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }